import React, { useEffect, useState } from "react";
import styles from "./subscribe.module.scss";
import { useAuthStore, useShowLoginModal } from "@/context/store";
import { useAttempts } from "@/utils/hooks/checkAttempts";

export default function Subscribe({
  redirectUrl,
  courseDetails,
  icon,
  isLearningPath,
}) {
  const [loggedInUser, setLoggedInUser] = useState({});
  const { setShowLoginModal } = useShowLoginModal();
  const { setPreviousPath } = useAuthStore();
  const { incrementAttempts } = useAttempts();

  useEffect(() => {
    let userData = localStorage.getItem("user");
    let parsedData;
    if (userData) {
      parsedData = JSON.parse(userData);
      if (parsedData?.email) {
        setLoggedInUser(parsedData);
      }
    } else {
      return;
    }
  }, []);

  const handleSubscribe = () => {
    if (loggedInUser?.email) {
      if (
        courseDetails?.progress?.hasStarted &&
        !courseDetails?.progress?.isCompleted
      ) {
        window.location.href = redirectUrl;
      } else if (courseDetails?.progress?.isCompleted) {
        return "Completed";
      } else {
        window.location.href = redirectUrl;
        return "Start Course";
      }
    } else {
      if (!isLearningPath) {
        incrementAttempts();
        window.location.href = redirectUrl;
      } else {
        setShowLoginModal(true);
        setPreviousPath(redirectUrl);
      }
    }
  };

  const getButtonText = () => {
    if (loggedInUser?.email) {
      if (
        courseDetails?.progress?.hasStarted &&
        !courseDetails?.progress?.isCompleted
      ) {
        return "Resume Learning";
      } else if (courseDetails?.progress?.isCompleted) {
        return "Completed";
      } else {
        return "Start Course";
      }
    } else {
      return "Start Now";
    }
  };

  const isCompleted =
    loggedInUser?.email && courseDetails?.progress?.isCompleted;

  return (
    <button
      className={`${styles["subscribe"]} outline-focussed`}
      onClick={handleSubscribe}
      data-swiftype-index="false"
      aria-label={getButtonText()}
      disabled={isCompleted}
      aria-disabled={isCompleted}
      type="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleSubscribe();
        }
      }}
      role="button"
      aria-pressed="false"
      data-testid="subscribe-button"
    >
      {icon && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fillRule="evenodd"
            strokeWidth="1.33333"
            clipRule="evenodd"
            d="M8.00005 0.03125C4.93856 0.03125 2.39993 2.40195 2.19073 5.45628L2.00261 8.20283C1.9446 9.04969 1.70083 9.87338 1.28859 10.6154L0.606133 11.8438C0.201122 12.5728 0.728276 13.4688 1.56224 13.4688H5.06854C5.08722 13.5856 5.11293 13.7015 5.14561 13.8159C5.26338 14.2279 5.46896 14.6096 5.74822 14.9346C6.02748 15.2597 6.37381 15.5204 6.7634 15.6989C7.15299 15.8774 7.5766 15.9695 8.00514 15.9687C8.43368 15.968 8.85698 15.8745 9.24595 15.6947C9.63493 15.5148 9.98035 15.2529 10.2585 14.9269C10.5366 14.6009 10.7409 14.2185 10.8573 13.8061C10.8886 13.6949 10.9134 13.5823 10.9316 13.4688H14.4378C15.2718 13.4688 15.799 12.5728 15.394 11.8438L14.7115 10.6154C14.2993 9.87338 14.0555 9.04969 13.9975 8.20283L13.8094 5.45628C13.6002 2.40195 11.0615 0.03125 8.00005 0.03125ZM9.97647 13.4688H6.02362C6.03073 13.4987 6.03853 13.5286 6.04701 13.5582C6.12759 13.8402 6.26825 14.1013 6.45932 14.3237C6.6504 14.5461 6.88736 14.7245 7.15392 14.8466C7.42048 14.9688 7.71032 15.0318 8.00353 15.0312C8.29674 15.0307 8.58637 14.9668 8.85251 14.8437C9.11865 14.7207 9.35499 14.5414 9.5453 14.3184C9.73561 14.0953 9.87538 13.8337 9.95499 13.5515C9.96274 13.5241 9.9699 13.4965 9.97647 13.4688ZM3.12603 5.52034C3.30155 2.95777 5.43147 0.96875 8.00005 0.96875C10.5686 0.96875 12.6985 2.95777 12.8741 5.52034L13.0622 8.26689C13.1296 9.25108 13.4129 10.2083 13.892 11.0707L14.5744 12.2991C14.6323 12.4033 14.557 12.5312 14.4378 12.5312H1.56224C1.4431 12.5312 1.3678 12.4033 1.42566 12.2991L2.10811 11.0707C2.5872 10.2083 2.87051 9.25108 2.93792 8.26689L3.12603 5.52034Z"
            fill="#6C5CE7"
          />
        </svg>
      )}
      {getButtonText()}
    </button>
  );
}
